<template>
  <b-modal :active.sync="value" :can-cancel="false" class="ModalTransaction">
      <div class="modals-bosy">
          <div class="col-12 text-center">
            <IconCancel fill="#f44336" width="20em"></IconCancel>
          </div>
          <div>
            <h3 class="title-modal">Transacción Rechazada</h3>
            <div class="col-12 text-lef-messages">
              <p v-if="msg !== ''">
                Motivo: <br>
                <b>{{ msg }}</b>
              </p>
              <h5 class="title-confirm">
                Por favor verifica otra forma de pago
              </h5>
            </div>
            <div class="btns-modal">
              <button
                type="button"
                @click="reintentar()"
                class="full-btn-modal btn-modal-fill"><i class="fa fa-reply"></i>&nbsp; Volverlo a intentar con otro medio</button>
            </div>
          </div>
      </div>
  </b-modal>
</template>
<script>
import IconCancel from '@/components/icons/iconCancel';
export default {
  components: { IconCancel },
  props: ['value', 'msg'],
  methods: {
    reintentar () {
      this.$emit('input', false);
      window.location.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
.ModalTransaction{
  .modals-bosy {
    background: var(--orderPopupBackground, #fff);
    border-radius: 10px;
    color: var(--orderPopupTextColor, #000);
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title-modal{
      text-align: center;
      color: var(--orderPopupTextColor, #000);
    }
    .text-lef-messages {
      border-top: unset;
    }
    .btns-modal{
      margin-top: 15px !important;
      display: flex;
      flex-wrap: wrap;
      button{
        width: 364px !important;
        padding: 10px !important;
        margin: auto !important;
        text-align:center;
        margin-top:10px !important;
        background: var(--orderPopupButtonBackground, var(--buttonBackground));
        color: var(--orderPopupButtonTextColor, var(--buttonTextColor));
        border: none;
        border-radius: 6px;
        cursor: pointer;
      }
    }
  }
}
</style>
